import Button from "@components/Button";
import { Modal } from "@components/core/Modal";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { ContentWrapper, SignInBox, SignInText } from "./AuthModal.style";
import { login } from "@lib/utils/auth";
import { getRequest } from "@lib/network/request";
import { redirectToURL } from "@lib/utils";

interface Props {
	show?: boolean;
	onClose: () => void;
}

const AuthModal: React.FC<Props> = ({
	onClose,
	show = false,
}) => {
	const { t } = useTranslation("translation");
	const router = useRouter();
	const redirectUrl = router.query?.next as string;
	const callbackUrl = redirectUrl ? redirectUrl : router.asPath;

	const onRegisterClick = async () => {
		const url = "/api/auth/register";
		const { data } = await getRequest({
			url: url,
		});
		redirectToURL(data);
	};

	return (
		<Modal
			onClose={() => onClose()}
			show={show}
			header={t("Account.CreateAccountOrLogIn")}
			showClose
			alignSelf="center"
		>
			<ContentWrapper>
				<Button
					onClick={() => onRegisterClick()}
					type="primary"
					width="100"
					data-testid="login-button-createaccount"
				>
					{t("Account.CreateAccount")}
				</Button>
				<SignInBox>
					<SignInText>{t("Account.AlreadyHaveAccount")}</SignInText>
					<Button
						className="underline-link"
						onClick={async () => await login(callbackUrl)}
					>
						{t("Actions.Login")}
					</Button>
				</SignInBox>
			</ContentWrapper>
		</Modal>
	);
};

export default AuthModal;
